// document.addEventListener("DOMContentLoaded", function () {
//     let nextBtn = document.querySelector("#paginate-next");

//     if (nextBtn) {
//       var elem = document.querySelector(".collection-con");
//       var infScroll = new InfiniteScroll(elem, {
//         path: "#paginate-next",
//         append: ".producto",
//         scrollThreshold: 500,
//         history: false,
//       });
//     };
// });

document.addEventListener("DOMContentLoaded", function () {
  const collectionCon = document.querySelector(".collection-con");
  const nextBtn = document.querySelector("#paginate-next");
  const paginationWrap = document.querySelector(".pagination-wrap");
  let nextUrl = nextBtn?.getAttribute("href");
  let loading = false;

  if (nextUrl && collectionCon) {
    // Create scroll trigger
    const trigger = document.createElement("div");
    trigger.id = "scroll-trigger";
    trigger.style.height = "1px";
    paginationWrap?.parentNode.insertBefore(trigger, paginationWrap);

    // Init ScrollMagic
    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: "#scroll-trigger",
      triggerHook: 1
    })
      .addTo(controller)
      .on("enter", function () {
        if (!loading && nextUrl) {
          loading = true;
          fetchNextPage(nextUrl);
        }
      });
  }

  function fetchNextPage(url) {
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelectorAll(".producto");
        const newNextBtn = doc.querySelector("#paginate-next");

        newProducts.forEach(product => {
          collectionCon.appendChild(product);
          if (typeof setProduct === "function") {
            setProduct(product);
          }
        });

        if (newNextBtn) {
          nextUrl = newNextBtn.getAttribute("href");
        } else {
          nextUrl = null;
          paginationWrap?.remove();
        }

        // Fallback: no products at all
        if (newProducts.length === 0) {
          nextUrl = null;
          paginationWrap?.remove();
        }

        loading = false;
      })
      .catch(err => {
        console.error("ScrollMagic infinite scroll failed:", err);
        loading = false;
      });
  }
});
